import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';

import { v4 as uuid } from 'uuid';

import { BriefingImageFrameEnum } from '../../../../Monitor/Shared/enums/briefing-image-frame.enum';
import { BriefingImageDisplayElementModel } from '../../../PageBuilder/models/briefing-image-display-element.model';
import { messageSeverityEnum } from '../../enums/message-severity.enum';
import { ImageSourceEnum } from '../../../PageBuilder/enums/image-source.enum';

@Component({
    selector: 'agpr-image-display',
    templateUrl: './image-display.component.html',
    styleUrls: ['./image-display.component.scss'],
    standalone: false,
})
export class ImageDisplayComponent implements OnChanges {

    @Input() data: BriefingImageDisplayElementModel;
    @Input() index: number;
    @Input() displayAutomateImagePlaceholder: boolean;
    @Input() includeEmptySections: boolean = true;
    @Input() showErrors: boolean;
    @Input() isPublished: boolean = false;

    @ViewChild('slideshowContainer') slideshowContainer!: ElementRef<HTMLDivElement>;

    readonly briefingImageFrame = BriefingImageFrameEnum;
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly imageSources = ImageSourceEnum;

    displaySize: number = 100;

    accentColor: string = '#0D74BA';

    slideIndex: number = 0;
    transitionTime: number = 5000;
    uniqueUUID: string = uuid();

    timeoutId: any;
    showAutomateIcon: boolean = false;

    hideSection: boolean = false;

    constructor(private cd: ChangeDetectorRef) {}

    ngOnChanges(): void {
        const allImagesFilled = this.data?.images.every(img => !!img.url);
        const hasAutomateImages = this.data?.images.some(img => img.imageSource === this.imageSources.AUTOMATE);

        if (!this.includeEmptySections) {
            this.hideSection = !allImagesFilled && !hasAutomateImages;
        }

        if (this.data?.imageEffects?.imageFrame === BriefingImageFrameEnum.COLLAGE && !allImagesFilled) {
            this.displayAutomateImagePlaceholder = true;
        }
        if (this.data?.images?.length > 1) {
            this.data.images = this.data?.images.sort((a, b) => a.location - b.location);
        }

        this.displaySize = (this.data?.imageProperties?.displaySize * 100) || 100;

        if (this.data?.imageEffects?.primaryColor) {
            this.accentColor = this.data?.imageEffects?.primaryColor;
        }

        this.transitionTime = this.data?.imageEffects?.transition * 1000 || 5000;

        this.slideIndex = 0;
        if (this.data?.imageEffects?.transition &&
            (this.data?.imageEffects?.imageFrame === this.briefingImageFrame.NO_FRAME) &&
            (this.data?.images?.length > 1)
        ) {
            requestAnimationFrame(() => {
                this.transitionImages();
            });

            setTimeout(() => this.adjustSlideshowHeight(), 500);
        }

        if (this.displayAutomateImagePlaceholder) {
            if (this.data?.imageEffects?.imageFrame === this.briefingImageFrame.COLLAGE || this.data?.imageEffects?.transition) {
                this.showAutomateIcon = hasAutomateImages;
            } else {
                // no frame no transition scenario
                this.showAutomateIcon = this.data?.images?.[0]?.imageSource === this.imageSources.AUTOMATE;
            }
        }
        this.cd.detectChanges();
    }

    transitionImages() {
        const slides = document.getElementsByClassName(
            this.uniqueUUID + '_transitionImages'
        ) as HTMLCollectionOf<HTMLElement>;

        if (!slides.length){
            return;
        }

        // remove active from all
        for (let i = 0; i < slides.length; i++) {
            slides[i].classList.remove('is-active');
        }

        // advance index and activate target
        this.slideIndex = (this.slideIndex + 1) % slides.length;
        slides[this.slideIndex].classList.add('is-active');
        this.cd.detectChanges();

        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => this.transitionImages(), this.transitionTime);
    }


    adjustSlideshowHeight() {
        const transitionImages = document.getElementsByClassName(this.uniqueUUID + '_transitionImages');
        let maxHeight = 0;

        for (let i = 0; i < transitionImages.length; i++) {
            const img = transitionImages[i].querySelector('img') as HTMLImageElement;
            if (img && img.clientHeight > maxHeight) {
                maxHeight = img.clientHeight;
            }
        }

        if (this.slideshowContainer?.nativeElement && maxHeight > 0) {
            this.slideshowContainer.nativeElement.style.height = maxHeight + 'px';
        }
    }
}
